// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"#fff","primaryColor":"#3495c9","secondaryColor":"#565656","content":"App_content__tFr1T","root":"App_root__CvLnw","snackbar":"App_snackbar__U2Um4"};